import { Autocomplete, TextField } from '@mui/material';
import { useGetCountryAndStateOptionsQuery } from '../Api/countryApi';
import { memo, SyntheticEvent } from 'react';

interface CountryOption {
  label: String;
  value: String;
}

interface CountryProps {
  name?: string;
  disabled?: boolean;
  size?: 'small' | 'medium';
  value?: string;
  label?: string;
  required?: boolean;
  error?: boolean;
  onChange?: (event: SyntheticEvent<Element, Event>, option: CountryOption | null, name?: string) => void;
}

const Country = ({ name, disabled, size, required, value, error, label, onChange }: CountryProps) => {
  const { data: countriesList } = useGetCountryAndStateOptionsQuery(
    {
      codetype: 'Country',
    }
    // {
    //   skip: value !== 'IndiaState',
    // }
  );
  console.log('ggggggggggg');

  const Change = (e: SyntheticEvent<Element, Event>, option: CountryOption | null) => {
    if (onChange) {
      onChange(e, option, name);
    }
  };

  // Generate a unique ID that doesn't match common address field names
  const uniqueId = name
    ? `country-${name.replace(/[^a-zA-Z0-9]/g, '-')}-${Math.random().toString(36).substr(2, 9)}`
    : `country-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <Autocomplete
      id={uniqueId}
      size={size}
      disabled={disabled}
      getOptionLabel={(option) => String(option.label)}
      value={countriesList?.find((option) => option?.value === value) || null}
      //   onBlur={onBlur}
      //   onKeyDown={onKeyDown}
      onChange={Change}
      options={countriesList || []}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          required={required}
          error={error}
          name={uniqueId}
          autoComplete="new-password"
          inputProps={{
            ...params.inputProps,
            autoComplete: 'new-password',
            autoCapitalize: 'off',
            autoCorrect: 'off',
            spellCheck: 'false',
            'data-form-type': 'other',
            'data-lpignore': 'true',
          }}
          InputProps={{
            ...params.InputProps,
            autoComplete: 'new-password',
          }}
          sx={{
            '.MuiFormLabel-asterisk': {
              color: 'danger.main',
              fontSize: '20px',
              fontWeight: 'bold',
            },
          }}
        />
      )}
    />
  );
};

export default memo(Country);
